import React, { useState, useRef, useEffect } from 'react';
import { View } from 'react-native';
import { useToast } from 'react-native-toast-notifications';
import { Page, DataGrid, BText, DataGridColumn, showToast, Drawer, PageTitle } from '../../../../components';
import { Button, Input, InputRefProps, ButtonContainer } from '../../../../components/Form';
import { UserInputSchema } from '../../../../types';
import eventCategoryJson from '../../../../assets/data/eventCategory.json';

export const AdminEventEventCategory = () => {
  type EventCategoryObject = {
    id: number;
    category: string;
    status: boolean;
  };

  const toast = useToast();
  const [isAddView, setIsAddView] = useState<boolean>(false);
  const [isEditView, setIsEditView] = useState<boolean>(false);
  const [selectedId, setSelectedId] = useState<number>(0);
  const [categoryName, setCategoryName] = useState<string>('');
  const inputCategoryName = useRef<InputRefProps>(null);
  const [showDelete, setShowDelete] = useState<boolean>(false);
  const [selectedCategory, setSelectedCategory] = useState<any>(null);
  const [eventCategory, setEventCategory] = useState(eventCategoryJson);

  useEffect(() => {
    updateInputValue(inputCategoryName.current, '');
  }, []);

  useEffect(() => {
    setSelectedId(selectedId);
  }, []);

  const column: DataGridColumn[] = [
    { label: 'Event Category', key: 'category', width: 100, sortable: true },
    {
      label: 'Status',
      key: 'status',
      width: 100,
      sortable: true,
      dataType: 'boolean',
      cellRender: (item: any) => <BText>{` ${item.status ? 'Active' : 'Inactive'}`}</BText>,
    },
  ];

  const handleActivationItem = (selectedItemIndex: any) => {
    const itemsToSelect = eventCategory.map(item => {
      if (selectedItemIndex.id === item.id) {
        return {
          ...item,
          status: !item.status,
        };
      }
      return item;
    }, []);
    setEventCategory(itemsToSelect);
    showToast(toast, {
      message: selectedItemIndex.status
        ? `${selectedItemIndex.category} is disabled`
        : `${selectedItemIndex.category} is enabled`,
    });
  };

  const updateInputValue = (element: InputRefProps | null, value: string) => {
    if (element) element.setValue(value);
  };

  const incrementId = () => {
    return isEditView ? selectedId : eventCategory[eventCategory.length - 1].id + 1;
  };

  const doSaveBtn = async () => {
    const newCategory: EventCategoryObject = {
      id: incrementId(),
      category: inputCategoryName.current?.value || '',
      status: true,
    };
    handleAddOrUpdate(newCategory);
    setIsAddView(false);
    clearInputValue();
  };

  const handleAddOrUpdate = (newCategory: EventCategoryObject) => {
    const existingCategoryIndex = eventCategory.findIndex(category => category.id === newCategory.id);

    if (existingCategoryIndex !== -1) {
      const updatedCategoryData = [...eventCategory];
      updatedCategoryData[existingCategoryIndex] = newCategory;
      setEventCategory(updatedCategoryData);
    } else {
      setEventCategory(prevData => [...prevData, newCategory]);
    }
  };

  const doCancelBtn = () => {
    setIsAddView(false);
    setIsEditView(false);
    clearInputValue();
  };

  const showEditItemView = (showSelectedCategory: any) => {
    setIsAddView(true);
    setIsEditView(true);
    populateSelectedEditItem(showSelectedCategory);
  };

  const populateSelectedEditItem = (populateSelectedCategory: any) => {
    setCategoryName(populateSelectedCategory.category);
    setSelectedId(populateSelectedCategory.id);
  };

  const showDeleteDrawer = (selectedItemIndex: any) => {
    setSelectedCategory(selectedItemIndex);
    setShowDelete(true);
  };

  const handleDeleteItem = () => {
    const updatedCategoryData = eventCategory.filter(category => category.category !== selectedCategory.category);
    setEventCategory(updatedCategoryData);
  };

  const clearInputValue = () => {
    if (!isAddView) {
      setCategoryName('');
    }
  };

  return (
    <Page title={'Event Category Setup'}>
      {!isAddView && (
        <View>
          <DataGrid
            data={eventCategory}
            columns={column}
            actions={[
              {
                label: 'Active',
                action: (item: any) => handleActivationItem(item),
                disable: (item: any) => item.status,
              },
              {
                label: 'Deactivate',
                action: (item: any) => handleActivationItem(item),
                disable: (item: any) => !item.status,
              },
              {
                label: 'Edit',
                action: (item: any) => showEditItemView(item),
              },
              {
                label: 'Delete',
                action: (item: any) => showDeleteDrawer(item),
                disable: (item: any) => !item.status,
              },
            ]}
            defaultSort={{ key: 'category', direction: 'ascending' }}
            // onDoubleClick={(item: any) => console.log('DblClick', item)}
            onSelect={(item: any) => console.log('select', item)}
            primaryButton={{
              label: 'Add Event Category',
              action: () => setIsAddView(true),
            }}
          />
        </View>
      )}

      {isAddView && (
        <View>
          {!isEditView ? <PageTitle>Add New Event Category</PageTitle> : <PageTitle>Edit Event Category</PageTitle>}
          <Input
            label={'Event Category Name'}
            id="categoryName"
            value={!isEditView ? '' : categoryName}
            schemaObject={UserInputSchema}
            schemaContext={{ isEdit: true }}
            ref={inputCategoryName}
          />
          <ButtonContainer direction="horizontal">
            <Button onPress={() => doSaveBtn()}>Save</Button>
            <Button onPress={() => doCancelBtn()}>Cancel</Button>
          </ButtonContainer>
        </View>
      )}

      <Drawer
        id="category.delete"
        visible={showDelete}
        type={'onCancel'}
        onClose={() => setShowDelete(false)}
        onOK={handleDeleteItem}
        title={'Confirmation'}
      >
        <BText>Are you confirm to delete the state?</BText>
      </Drawer>
    </Page>
  );
};
